module.exports = __webpack_public_path__ + "324b4d088649e13437a7f4623624cc1f.svg";